import {
  BrandAndMarketListItem,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
} from '../../../integrated-client/models';
import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  showDisabled?: boolean;
  brandAndMarket?: BrandAndMarketListItem| null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null
  offset: number;
  limit: number;
  total: number
  currentPage: number
}

export class FormData implements IFormData {
  showDisabled?: boolean;
  brandAndMarket?: BrandAndMarketListItem| null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null
  offset: number;
  limit: number;
  total: number
  currentPage: number

  constructor() {
    this.showDisabled = false
    this.brandAndMarket = null
    this.distributionChannel = null
    this.agency = null
    this.offset = 0
    this.limit = DEFAULT_LIMIT
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage = 1
  }

}
